/*
 * Copyright (c) 2023. iSecNew10 Enterprises LLC
 */

import React from 'react'

import './LoadingRoot.css';
import Loader from '../../assets/images/loader.gif'

const LoadingRoot = (props: {
    isLoading: boolean,
    inline?: boolean
}) => {
    const {isLoading, inline} = props
    return isLoading ?
        inline ? (
            <div style={{
                textAlign: 'center',
                margin: 100
            }}>
                <div className='loader-root__box'></div>
            </div>
        ) : (
        <div id="loadingAppRoot">
            <div id="loadingSpinner">
                <img alt="loader gif" src={Loader}/>
            </div>
        </div>
    ) : null
}

export default LoadingRoot
